import { makeGroupLabelOverrideKey } from '@digital-twins/shared-types'

interface GroupLabelOverrideSource {
  /** The group's wizard id — the key under which its alias is stored. */
  groupId: string
  /** Member (source) columns the alias should ride on. */
  memberColumns: Array<string>
}

/**
 * Expand the wizard's flat `customLabels` map into the shape sent on create.
 *
 * Single-column aliases (keyed by `sourceColumn`) pass through untouched. A
 * grouped-question alias (keyed by the group's wizard id) is expanded into one
 * sentinel entry per member column so the backend can attach `groupDisplayLabel`
 * to every member's segmentation mapping — letting the alias survive Argo
 * regrouping and show consistently in the study-creation filter modal.
 */
export function expandCustomLabelsForCreate(
  customLabels: Record<string, string>,
  groups: Array<GroupLabelOverrideSource>,
): Record<string, string> {
  const groupIds = new Set(groups.map((g) => g.groupId))
  const out: Record<string, string> = {}

  for (const [key, label] of Object.entries(customLabels)) {
    if (groupIds.has(key)) {
      continue
    }
    out[key] = label
  }

  for (const group of groups) {
    const label = customLabels[group.groupId]?.trim()
    if (!label) {
      continue
    }
    for (const column of group.memberColumns) {
      out[makeGroupLabelOverrideKey(column)] = label
    }
  }

  return out
}
